module.exports = __webpack_public_path__ + "img/Group 1306.0ba5a25.png";